import { EMPTY, interval, map, Observable, takeWhile, timer } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DestroyRef } from '@angular/core';

export class TimerTools {
  public static interval$(intervalMs: number, destroyRef?: DestroyRef): Observable<number> {
    return interval(intervalMs).pipe(takeUntilDestroyed(destroyRef));
  }

  public static timer$(timeoutMs: number, destroyRef?: DestroyRef): Observable<0> {
    return timer(timeoutMs).pipe(takeUntilDestroyed(destroyRef));
  }

  /** Emits the time of each tick, counted back from `endsAt` so the last lands on it and never earlier than the clock; nothing without an end or once it has passed. */
  public static nowUntil$(endsAt: Date | undefined, intervalMs: number): Observable<number> {
    if (endsAt === undefined) {
      return EMPTY;
    }
    const now = Date.now();
    const remainingMs = endsAt.getTime() - now;
    if (remainingMs <= 0) {
      return EMPTY;
    }
    const firstTickMs = remainingMs % intervalMs || intervalMs;
    const firstTickAt = now + firstTickMs;
    return timer(firstTickMs, intervalMs).pipe(
      map(tick => Math.max(Date.now(), firstTickAt + tick * intervalMs)),
      takeWhile(tickAt => tickAt < endsAt.getTime(), true),
    );
  }

  public static nextTick(fn: () => void): void {
    setTimeout(fn, 0);
  }
}
